import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import BlockHeader from 'components/common/BlockHeader';
import SubHeading from 'components/common/SubHeading';
import Image from 'components/common/Image';
import i18n from 'i18n';
import imgPaymentPC1x from 'assets/images/PC/@1x/img_payment.png';
import imgPaymentPC2x from 'assets/images/PC/@2x/img_payment@2x.png';
import imgPaymentSP2x from 'assets/images/SP/@2x/img_payment@2x.png';
import imgPaymentSP3x from 'assets/images/SP/@3x/img_payment@3x.png';

const Bank = ({ className }) => (
  <div className={className}>
    <BlockHeader>{i18n.t('about:payment:bank.header')}</BlockHeader>
    <div className="input-items">
      <SubHeading>{i18n.t('about:payment:bank.account.header')}</SubHeading>
      <p className="description">
        {i18n.t('about:payment:bank.account.description')}
      </p>
    </div>
    <div className="input-items">
      <SubHeading>{i18n.t('about:payment:bank.remitter.header')}</SubHeading>
      <p className="description">
        {i18n.t('about:payment:bank.remitter.description')}
      </p>
      <p className="tips">{i18n.t('about:payment:bank.remitter.tips')}</p>
      <Image
        pc1x={imgPaymentPC1x}
        pc2x={imgPaymentPC2x}
        sp2x={imgPaymentSP2x}
        sp3x={imgPaymentSP3x}
        alt="img_payment"
      />
      <ul>
        {i18n
          .t('about:payment:bank.remitter.additions', { returnObjects: true })
          .map((addition, i) => (
            <li key={i}>{addition}</li>
          ))}
      </ul>
    </div>
  </div>
);

const commonStyle = css`
  .input-items {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .description {
    color: ${Colors.black1};
    margin: 0;
  }

  .tips {
    color: ${Colors.black1};
    padding-left: 20px;
    position: relative;

    &:before {
      content: '※';
      position: absolute;
      left: 0;
    }
  }

  ul {
    padding-left: 13px;

    li {
      color: ${Colors.black1};
      list-style: none;
      position: relative;

      &:before {
        content: '●';
        position: absolute;
        left: -11px;
        font-size: 7px;
      }
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  ${SubHeading} {
    margin-bottom: 8px;
  }

  picture {
    img {
      margin: 24px 0 4px;
    }
  }

  .description {
    ${FontStyles.text8};
  }

  .tips {
    ${FontStyles.text10};
    margin: 8px 0 0;
  }

  ul {
    margin-bottom: 0;

    li {
      ${FontStyles.text8};
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  ${SubHeading} {
    margin-bottom: 13px;
    ${FontStyles.text5};
  }

  picture {
    img {
      margin: 4px 0;
      max-width: 100%;
    }
  }

  .description {
    ${FontStyles.text6};
  }

  .tips {
    ${FontStyles.text8};
    margin: 6px 0 24px;
  }

  ul {
    margin-top: 24px;
    margin-bottom: 0;

    li {
      ${FontStyles.text6};
    }
  }
`;

export default applyStyles(Bank)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/About/Payment/components/Bank.js